import { SessionLayer } from "../../interfaces";
import { getAppBFFUrl } from "../functions";
import { formatData, handleError, handleStepSuccessEvent, getTenant } from "./api";
import { sendDataToBuffer } from "./sendDataToBuffer";

export const sendDigaRedeem = async (
  data: SessionLayer,
  requestConditions: any,
) => {
  const { lead_data, push_data, marketing_data } = data;
  const {
    is_last_step,
    hasSuccessStep,
    defaultSuccessPageUrl,
    successPageRules,
  } = requestConditions;
  const formCompleted = is_last_step || hasSuccessStep;
  const formattedData = await formatData(
    lead_data,
    push_data,
    marketing_data,
    formCompleted,
    true,
  );
  const baseUrl = await getAppBFFUrl();

  const tenant = getTenant();
  if (!tenant) {
    return {
      res: new Response(null, { status: 400 }),
      details: "Invalid or missing tenant",
    };
  }

  const requestBody = {
    diga_code: formattedData.get("diga_code"),
    email: formattedData.get("email"),
  };

  try {
    const res = await fetch(`${baseUrl}/payment/api/v1/public/diga/verify`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-tenant": tenant,
      },
      body: JSON.stringify(requestBody),
    });

    if (res.status === 201) {
      await handleStepSuccessEvent(
        res,
        is_last_step,
        hasSuccessStep,
        defaultSuccessPageUrl,
        successPageRules,
      );

      sendDataToBuffer(data, requestConditions).catch(() => {});
    }

    const details =
      res.status === 201
        ? undefined
        : (await res.json().catch(() => ({})))?.detail;
    return { res, details };
  } catch (error) {
    return handleError(error);
  }
};
